import {
    get_macchine,
    get_macchina,
    get_macchina_by_qr,
    get_macchina_kpi,
    create_macchina,
    update_macchina,
    duplica_macchina,
    delete_macchina,
} from "@/api/api.macchina.js";

const macchine = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
        kpi: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, macchina) => {
            state.corrente = macchina;
        },
        SET_KPI: (state, kpi) => {
            state.kpi = kpi;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_macchine(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_macchina(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDaQr({ commit }, publicCode) {
            return new Promise((resolve, reject) => {
                get_macchina_by_qr(publicCode).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaKpi({ commit }) {
            return new Promise((resolve, reject) => {
                get_macchina_kpi().then(resp => {
                    commit("SET_KPI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva(_ctx, { id, dati }) {
            return id ? update_macchina(id, dati) : create_macchina(dati);
        },

        elimina(_ctx, { id, conferma } = {}) {
            return delete_macchina(id, conferma);
        },

        duplica(_ctx, id) {
            return duplica_macchina(id);
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
        kpi: state => state.kpi,
    },
};

export default macchine;